import React from 'react';
import {
  Box,
  FormControl,
  FormLabel,
  Radio,
  RadioGroup,
} from '@material-ui/core';
import { getIn, useFormikContext } from 'formik';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { NewCentralFormType } from '../types';

type Props = {
  name: string;
  options: { value: string; label: string }[];
  label: string;
  disabled?: boolean;
};

const SearchRadioGroup: React.FC<Props> = ({
  name,
  options,
  label,
  disabled,
}) => {
  const { values, handleChange } = useFormikContext<NewCentralFormType>();
  const value = getIn(values, name) as string;
  return (
    <>
      <FormControl component="fieldset">
        <FormLabel component="legend">{label}</FormLabel>
        <RadioGroup name={name} value={value} onChange={handleChange}>
          <Box>
            {options.map((option) => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<Radio />}
                label={option.label}
                disabled={disabled}
              />
            ))}
          </Box>
        </RadioGroup>
      </FormControl>
    </>
  );
};
export default SearchRadioGroup;
